import { STATUS_DICTIONARY } from '../constants/status-dictionary.constant';

export const hideComponent = (status) => (status === STATUS_DICTIONARY.close ? 'none' : '');
